import { Injectable } from '@angular/core';
import { IonIntlTelInputModel } from 'src/app/shared/libs/ion-intl-tel-input/models/ion-intl-tel-input.model';
import { CountryISO } from '../enum/country-iso.enum';
import parsePhoneNumber from 'libphonenumber-js';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  deepClone(data: unknown): unknown {
    return JSON.parse(JSON.stringify(data));
  }

  limitString(string: string, maxLength: number): string {
    return string.length > maxLength
      ? string.substring(0, maxLength - 3) + '...'
      : string;
  }

  getBrowserCountryCode(): CountryISO {
    // user's preferred language
    const lang = navigator.language.split('-');
    const languageCode = lang[0];
    const countryCode = lang.length > 1 ? lang[1] : languageCode;
    let countryName = Object.keys(CountryISO).find(
      (key) => CountryISO[key] === countryCode?.toLowerCase(),
    );

    // Fallback to all user's preferred languages
    if (!countryName) {
      let i = 0;
      while(i < navigator.languages.length) {
        const fallBackLang = navigator.languages[0].split('-');
        const fallBackLanguageCode = fallBackLang[0];
        const fallBackcountryCode = fallBackLang.length > 1 ? fallBackLang[1] : fallBackLanguageCode;
        
        countryName = Object.keys(CountryISO).find(
          (key) => CountryISO[key] === fallBackcountryCode?.toLowerCase(),
        );

        if (countryName) {
          break;
        }

        i++;
      }
    }

    return CountryISO[countryName] ?? CountryISO.Sweden;
  }

  constructTelInputModel(internationalNumber: string): IonIntlTelInputModel {
    const parsedNumber = parsePhoneNumber(internationalNumber);
    return {
      dialCode: parsedNumber.countryCallingCode,
      internationalNumber: parsedNumber.number,
      isoCode: parsedNumber.country.toLowerCase(),
      nationalNumber: parsedNumber.formatNational(),
    };
  }

  cleanInternationalPhoneNumber(phoneInput: string): string {
    const parsedNumber = parsePhoneNumber(phoneInput);
    return parsedNumber.number;
  }

  getPhoneNumberUri(phoneNumber: string): string {
    const parsedNumber = parsePhoneNumber(phoneNumber);
    return parsedNumber.getURI();
  }

  formatPhoneNumber(phoneNumber: string): string {
    const parsedNumber = parsePhoneNumber(phoneNumber);
    return parsedNumber.formatInternational();
  }

  linkToClipboard(link: string): void {
    if (!navigator.clipboard) {
      this.fallbackCopyLinkToClipboard(link);
      return;
    }
    navigator.clipboard.writeText(link);
  }

  fallbackCopyLinkToClipboard(link: string): void {
    try {
      const textArea = document.createElement('textarea');
      textArea.value = link;
    
      textArea.style.top = '-999999px';
      textArea.style.left = '-999999px';
      textArea.style.position = 'fixed';
    
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      // execCommand technically deprecated. 
      // but the "right" way using ClipboardAPI does not work well on Safari or Firefox 
      // and have trouble with Typescript
      document.execCommand('copy');
      document.body.removeChild(textArea);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
  }
}
